<template>
  <div>
    <Modal title="增加接口" v-model="addInterfaceModal">
      <Form :model="addForm" ref="addForm" :rules="addRules">
        <FormItem label="网络" prop="network_id">
          <Select v-model="addForm.network_id" @on-change="getSubNetList" filterable>
            <Option v-for="item in networkList" :key="item.id" :value="item.id"
                    v-if="item.tenant_id === $store.state.privateCloud.selPrivateCloudProject">{{ item.name }} - {{ item['router:external'] ? '外网': '内网' }}</Option>
          </Select>
        </FormItem>
        <FormItem label="子网" prop="subnet_id">
          <Select v-model="addForm.subnet_id" not-found-text="请选择拥有子网的网络" filterable>
            <Option v-for="subNetItem in subnetList" :key="subNetItem.id" :value="subNetItem.id">{{ subNetItem.name }} ({{ subNetItem.cidr }})</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addInterfaceSubmit" :loading="addInterfaceLoading">提交</Button>
        <Button @click="addInterfaceModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Row class="title">
      <h4 :style="{float: 'left'}">接口</h4>
      <a v-on:click="getPorts()" style="line-height: 40px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
      <div :style="{float: 'right'}">
        <Button type="primary" @click="addInterfaceModal = true" style="margin-right: 10px">增加接口</Button>
      </div>
    </Row>
    <Alert v-if="ports.error" type="warning" show-icon>获取端口数据失败</Alert>
    <Table
      v-else
      border
      size="small"
      :loading="ports.loading"
      ref="routeInterfaceTable"
      :data="ports.data"
      :columns="ports.columns">
    </Table>
    <div style="margin: 10px 0; overflow: hidden;">
      <div style="float: right;">
        <page
          :total="ports.count"
          :current="ports.page"
          :page-size="ports.size"
          @on-change="getPorts"></page>
      </div>
    </div>
  </div>
</template>

<script>
import { operatePrivateCloudRouterInterface } from '@/api/private-cloud/router-interface'
import { getPrivateCloudPort } from '@/api/private-cloud/port'
import { getPrivateCloudAllNetwork } from '@/api/private-cloud/network'
import { getPrivateCloudAllSubnet } from '@/api/private-cloud/subnet'

export default {
  name: 'port-list',
  data () {
    return {
      ports: {
        data: [],
        columns: [
          {
            title: '接口名称',
            align: 'center',
            minWidth: 130,
            tooltip: true,
            render: (h, params) => {
              let name = params.row.name
              if (!name) {
                name = '无'
              }
              return h('div', name)
            }
          },
          {
            title: '固定IP',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              const fixedIps = params.row.fixed_ips
              let result = []
              for (let i in fixedIps) {
                result.push(h('p', fixedIps[i].ip_address))
              }
              return h('div', result)
            }
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'ACTIVE' ? 'success'
                : status === 'DOWN' || status === 'BUILD' ? 'warning'
                  : status === 'ERROR' ? 'error'
                    : 'warning'
              let text = status === 'ACTIVE' ? '运行'
                : status === 'BUILD' ? '构建中'
                  : status === 'DOWN' ? 'Down'
                    : status === 'ERROR' ? '错误'
                      : status
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '管理状态',
            align: 'center',
            minWidth: 70,
            key: 'admin_state_up',
            render: (h, params) => {
              let res = '是'
              if (!params.row.admin_state_up) {
                res = '否'
              }
              return h('span', res)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除此接口吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除接口')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        error: false,
        loading: false
      },
      networkList: [],
      subnetList: [],
      addInterfaceModal: false,
      addInterfaceLoading: false,
      addForm: {
        action: 'add',
        network_id: '',
        subnet_id: ''
      },
      addRules: {
        network_id: [
          { required: true, message: '请选择拥有子网的网络', trigger: 'change' }
        ],
        subnet_id: [
          { required: true, message: '请选择子网', trigger: 'change' }
        ]
      }
    }
  },
  props: {
    router_id: {
      type: String,
      required: true
    }
  },
  watch: {
    'router_id' () {
      if (this.router_id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
    this.getNetworkListData()
  },
  methods: {
    init () {
      this.getPorts()
    },
    getPorts (value = 1) {
      this.ports.page = value
      this.ports.loading = true
      let params = {
        device_owner: 'network:router_interface',
        device_id: this.router_id,
        page: this.ports.page,
        size: this.ports.size
      }
      getPrivateCloudPort(params).then(res => {
        this.ports.error = false
        let result = res.data
        this.ports.data = result.results
        this.ports.count = result.count
        this.ports.loading = false
      }).catch(res => {
        this.ports.error = true
        this.ports.loading = false
      })
    },
    // 删除端口
    delete (id) {
      let reqData = {
        action: 'remove',
        port_id: id
      }
      operatePrivateCloudRouterInterface(reqData, this.router_id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getPorts()
      }).catch(res => {
        if (res.response) {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！',
            desc: res.response.data
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 获取网络列表
    getNetworkListData () {
      getPrivateCloudAllNetwork().then(res => {
        this.networkList = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取网络列表失败！'
        })
        console.error(res.response)
      })
    },
    // 获取子网列表
    getSubNetList (id) {
      this.addForm.subnet_id = ''
      if (id) {
        getPrivateCloudAllSubnet({ network_id: id }).then(res => {
          console.log(res.data)
          this.subnetList = res.data
        }).catch(res => {
          this.subnetList = []
          console.error(res.response)
        })
      } else {
        this.subnetList = []
      }
    },
    // 增加接口
    addInterfaceSubmit () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addInterfaceLoading = true
          operatePrivateCloudRouterInterface(this.addForm, this.router_id).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.addInterfaceModal = false
            this.getPorts()
            this.addInterfaceLoading = false
          }).catch(res => {
            this.addInterfaceLoading = false
            if (res.response) {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！',
                desc: res.response.data
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
